import { PageHeader, Reveal, Eyebrow } from "@/components/site/Reveal";
import Manifesto from "@/components/site/Manifesto";
import Global from "@/components/site/Global";
import FinalCTA from "@/components/site/FinalCTA";

export default function AboutPage() {
    return (
        <div data-testid="about-page">
            <PageHeader
                eyebrow="About"
                title={
                    <>
                        A small team with a <span className="text-brand">builder's mindset</span>.
                    </>
                }
                sub="Apan Code Labs LLP is a software development company focused on building thoughtful digital products, high-performance websites and custom software for modern businesses."
            />
            <section className="border-b border-slate-200 bg-white py-16 sm:py-20">
                <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                    <Reveal className="flex flex-wrap items-center gap-x-10 gap-y-4">
                        <Eyebrow testId="about-approach-eyebrow">Approach</Eyebrow>
                        <p className="font-display text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
                            Engineering <span className="text-slate-300">·</span> Design{" "}
                            <span className="text-slate-300">·</span> Product Thinking
                        </p>
                    </Reveal>
                </div>
            </section>
            <Manifesto />
            <Global />
            <FinalCTA />
        </div>
    );
}
